import { Component, EventEmitter, Input, Output, ElementRef } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
  selector: 'evsb-panel',
  templateUrl: './panel.component.html',
  styleUrls: ['./panel.component.scss'],
})
export class PanelComponent {
  @Input()
  public open = false;
  @Output()
  public didChange = new EventEmitter<PanelComponent>();
  @Output()
  public didOpen = new EventEmitter<void>();
  @Input()
  public canOpen = true;
  public animationFinished = new Subject<void>();

  constructor(public element: ElementRef) {}

  public toggle() {
    if (!this.open && !this.canOpen) {
      return;
    }
    this.open = !this.open;
    this.didChange.emit(this);
    if (this.open) {
      this.didOpen.emit();
    }
  }

  public sendAnimationFinished() {
    this.animationFinished.next();
  }
}
